import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// Botón compacto para copiar un serial de ticket al portapapeles.
export const CopyCodeButton = ({ code, size = 13, className = "", label, testId }) => {
  const [done, setDone] = useState(false);
  if (!code) return null;
  const copy = async (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    try {
      await navigator.clipboard.writeText(code);
      setDone(true);
      toast.success(label ? `${label} copiado` : `Serial ${code} copiado`);
      setTimeout(() => setDone(false), 1200);
    } catch {
      toast.error("No se pudo copiar");
    }
  };
  return (
    <button type="button" onClick={copy} title={label ? `Copiar ${label.toLowerCase()}` : "Copiar serial"} aria-label={label ? `Copiar ${label}` : `Copiar serial ${code}`} data-testid={testId || `copy-code-${code}`}
      className={`inline-flex items-center justify-center rounded p-1 text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors align-middle ${className}`}>
      {done ? <Check size={size} className="text-emerald-600" /> : <Copy size={size} />}
    </button>
  );
};

export const CopyCode = ({ code, children, className = "", size }) => (
  <span className={`inline-flex items-center gap-1 ${className}`}>
    {children ?? code}
    <CopyCodeButton code={code} size={size} />
  </span>
);

export default CopyCode;
